var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"my-policy-float",on:{"click":_vm.goPolicies}},[_c('span',{staticClass:"mpf-icon"},[_vm._v("📄")]),_c('span',{staticClass:"mpf-text"},[_vm._v("我的保单")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }